//
// locales/vanilla/ru.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/ru.json';
import localeData from 'react-intl/locale-data/ru.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
